import { create } from "zustand";

type TIntroLogoStore = {
	isVisible: boolean;
	show: () => void;
	hide: () => void;
};

export const useIntroLogoStore = create<TIntroLogoStore>()((set) => ({
	isVisible: false,
	show: () => set({ isVisible: true }),
	hide: () => set({ isVisible: false }),
}));
